"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableLine = void 0;
var tslib_1 = require("tslib");
var drawable_1 = require("./drawable");
var label_drawable_1 = require("./label.drawable");
var line_point_drawable_1 = require("./line.point.drawable");
/**
 * Line is a "Width Marker" which also has a Label, a start point, and an end point.
 */
var CollectionModelDrawableLine = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelDrawableLine, _super);
    function CollectionModelDrawableLine(collectionModelDrawableState, drawableId, labelId, startId, endId) {
        var _this = _super.call(this, collectionModelDrawableState, drawableId) || this;
        _this._labelId = labelId;
        _this._startId = startId;
        _this._endId = endId;
        return _this;
    }
    CollectionModelDrawableLine.createWithLinePointsAndLabel = function (drawableState, id, startPoint, endPoint, labelPoint, text, links) {
        var label = new label_drawable_1.CollectionModelDrawableLabel(drawableState, "".concat(id, ":label"), labelPoint.x, labelPoint.y, id, text, links);
        var start = new line_point_drawable_1.CollectionModelDrawableLinePoint(drawableState, "".concat(id, ":start"), startPoint.x, startPoint.y, id);
        var end = new line_point_drawable_1.CollectionModelDrawableLinePoint(drawableState, "".concat(id, ":end"), endPoint.x, endPoint.y, id);
        var line = new CollectionModelDrawableLine(drawableState, id, label.id, start.id, end.id);
        return { line: line, start: start, end: end, label: label };
    };
    CollectionModelDrawableLine.isLine = function (t) {
        return t instanceof CollectionModelDrawableLine;
    };
    Object.defineProperty(CollectionModelDrawableLine.prototype, "x", {
        get: function () {
            return this.start.x;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableLine.prototype, "y", {
        get: function () {
            return this.start.y;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableLine.prototype, "start", {
        get: function () {
            return this.drawableState.getDrawable(this._startId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableLine.prototype, "end", {
        get: function () {
            return this.drawableState.getDrawable(this._endId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableLine.prototype, "label", {
        get: function () {
            return this.drawableState.getDrawable(this._labelId);
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableLine.prototype.getLabelConnectionPoint = function (_options) {
        var startPoint = this.start;
        var endPoint = this.end;
        var midX = (startPoint.x + endPoint.x) / 2;
        var midY = (startPoint.y + endPoint.y) / 2;
        return { x: midX, y: midY };
    };
    Object.defineProperty(CollectionModelDrawableLine.prototype, "value", {
        get: function () {
            return this.drawableState.collection.state
                .getGeometry(this.captureId)
                .calculateDistance(this.start.getVector(), this.end.getVector());
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableLine.prototype.remove = function () {
        _super.prototype.remove.call(this);
        // Remove this line's label too, unless it has already been removed
        if (this.drawableState.hasDrawable(this._labelId)) {
            this.label.remove();
        }
    };
    Object.defineProperty(CollectionModelDrawableLine.prototype, "isInsightMeasurement", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableLine.prototype.isApprovableInsightDrawable = function () {
        return false;
    };
    Object.defineProperty(CollectionModelDrawableLine.prototype, "isVisible", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableLine.prototype.clone = function (newParentDrawableState) {
        if (!newParentDrawableState.hasDrawable(this._labelId)) {
            this.label.clone(newParentDrawableState);
        }
        return new CollectionModelDrawableLine(newParentDrawableState, this.id, this._labelId, this._startId, this._endId);
    };
    CollectionModelDrawableLine.prototype.equals = function (other) {
        return (other instanceof CollectionModelDrawableLine
            && this._startId === other._startId
            && this._endId === other._endId
            && this._labelId === other._labelId
            && this._equals(other));
    };
    return CollectionModelDrawableLine;
}(drawable_1.CollectionModelDrawable));
exports.CollectionModelDrawableLine = CollectionModelDrawableLine;
//# sourceMappingURL=line.drawable.js.map